/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { SelectWithSearch } from "@/components/form-input";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { FileText, LucideLoaderCircle, XIcon } from "lucide-react";
import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useReprocessDocument } from "./hook/use-reprocess-document";
import { SelectRetailer } from "@/components/form-input/select-retailer";
import { apiServices } from "@/services/api.services";
import { retailers } from "@/services/global.services";
import { useToast } from "@/hooks/use-toast";
import { useProcess } from "@/global-data";

type ReprocessDocumentProps = {
  allRetailerList: any;
  selectedRetailer?: any;
  workflowList: any;
  currentCompanyData: any;
  onAction: any;
  doc_id: any;
  company_id: string;
  user_id: string;
  loadingList: any;
  globalLoading: boolean;
  setGlobalLoading: (prop: boolean) => void;
  disabled?: boolean;
};
export const ReprocessDocument = ({
  workflowList,
  currentCompanyData,
  doc_id,
  company_id,
  user_id,
  loadingList,
  globalLoading,
  setGlobalLoading,
  // allRetailerList,
  selectedRetailer,
  disabled,
}: ReprocessDocumentProps) => {
  const {
    reProcessCurrentDocument,
    process,
    reprocessDocumentState,
    setReprocessDocumentState,
  } = useReprocessDocument({
    company_id,
    user_id,
    loadingList,
    currentCompanyData,
    doc_id,
    globalLoading,
    setGlobalLoading,
  });
  const [open, setOpen] = useState(false);
  const [retailerId, setRetailerId] = useState(selectedRetailer);
  const { toast } = useToast();
  const [allRetailerList, setAllRetailerList] = useState([]);

  useEffect(() => {
    setRetailerId(selectedRetailer);
  }, [selectedRetailer]);

  const loadingRetailer = async () => {
    const payload = {
      data: {
        filter_by: {
          search_text: "",
          exact_match: false,
          list_customer_name: true,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      retailers.get,
      "post",
      payload,
    );

    if (data) {
      setAllRetailerList(data.result.metadata?.[retailers.key]);
    }

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const onSubmit = () => {
    if (reprocessDocumentState.doc_id && reprocessDocumentState.workflow_id) {
      const payload = {
        doc_id: reprocessDocumentState.doc_id,
        workflow_id: reprocessDocumentState.workflow_id,
        retailer_id: retailerId,
      };
      if (retailerId === "") {
        delete payload.retailer_id;
      }
      reProcessCurrentDocument(payload);
      setOpen(false);
    }
  };

  const { setProcess } = useProcess();

  useEffect(() => {
    (async () => {
      if (open) {
        setProcess(true);
        await loadingRetailer();
        setProcess(false);
      }
    })();
  }, [open]);

  return (
    <div>
      <Tooltip>
        <TooltipTrigger disabled={globalLoading || disabled} asChild>
          <Button
            variant={"ghost"}
            className="text-primary"
            onClick={() => setOpen(true)}
            size={"icon"}
            disabled={globalLoading || disabled}
          >
            {process ? (
              <LucideLoaderCircle className="animate-spin" />
            ) : (
              <FileText />
            )}
          </Button>
        </TooltipTrigger>

        <TooltipContent>
          <p>Document Reprocess</p>
          <TooltipArrow />
        </TooltipContent>
      </Tooltip>

      {open
        ? createPortal(
            <div className="fixed left-0 top-0 w-full h-full bg-black/50 flex justify-center items-center z-[999]">
              <div className="bg-white w-[45%] rounded-md flex flex-col relative">
                <div className="justify-between items-center w-full flex border border-l-0 border-r-0 border-t-0 px-6 py-2 mb-3 pr-2">
                  <h3 className="text-md font-bold">Document Reprocess</h3>
                  <Button variant={"ghost"} onClick={() => setOpen(false)}>
                    <XIcon />
                  </Button>
                </div>
                <div className="flex flex-col gap-x-6 gap-y-5 pt-4 px-6">
                  <SelectWithSearch
                    bindLabel="name"
                    bindValue="workflow_id"
                    placeholder="Select Workflow"
                    options={workflowList}
                    defaultValue={
                      currentCompanyData?.settings?.default_workflow
                    }
                    onChange={(prop: string) =>
                      setReprocessDocumentState((prev) => ({
                        ...prev,
                        workflow_id: prop,
                      }))
                    }
                    value={reprocessDocumentState.workflow_id}
                  />
                </div>
                <div className="flex flex-col gap-x-6 gap-y-5 pt-4 px-6">
                  <SelectRetailer
                    bindLabel="retailer_name"
                    bindValue="retailer_id"
                    placeholder="Select Retailer"
                    options={allRetailerList}
                    onChange={(prop: string) => setRetailerId(prop)}
                    value={retailerId}
                    clearable={true}
                  />
                </div>
                <div className="mt-10 px-6 py-4 flex gap-5 w-full border border-r-0 border-l-0 border-b-0">
                  <Button
                    type="submit"
                    className="w-[220px]"
                    onClick={() => onSubmit()}
                    // disabled={form.formState.isSubmitting}
                  >
                    Reprocess Document
                  </Button>
                  <Button
                    type="submit"
                    onClick={() => setOpen(false)}
                    variant={"outline"}
                    className="w-[220px]"
                  >
                    Close
                  </Button>
                </div>
              </div>
            </div>,
            document?.body,
          )
        : null}
    </div>
  );
};
